import { motion } from 'motion/react'
import type { ReactNode } from 'react'
import { fadeInStagger } from '~/lib/utils/animations'

type HeroSectionProps = {
  title: string
  subtitle?: string
  children?: ReactNode
  className?: string
  showWave?: boolean
}

export const HeroSection = ({
  title,
  subtitle,
  children,
  className = '',
  showWave = false,
}: HeroSectionProps) => {
  return (
    <div className={`relative py-32 ${className}`}>
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="mx-auto max-w-4xl">
          <motion.div
            initial="initial"
            animate="animate"
            variants={fadeInStagger()}
            className="space-y-8 text-center"
          >
            <h1 className="text-4xl font-bold tracking-tight text-white [text-shadow:0_1px_2px_rgb(0_0_0/20%)] sm:text-7xl">
              {title}
            </h1>
            {subtitle && (
              <p className="text-xl leading-8 text-white [text-shadow:0_1px_2px_rgb(0_0_0/20%)] sm:text-2xl">
                {subtitle}
              </p>
            )}
            {children}
          </motion.div>
        </div>
      </div>

      {showWave && (
        <div className="absolute bottom-0 left-0 w-full rotate-180 overflow-hidden leading-none">
          <svg
            className="relative block h-[50px] w-full"
            data-name="Layer 1"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 1200 120"
            preserveAspectRatio="none"
          >
            <path
              d="M321.39,56.44c58-10.79,114.16-30.13,172-41.86,82.39-16.72,168.19-17.73,250.45-.39C823.78,31,906.67,72,985.66,92.83c70.05,18.48,146.53,26.09,214.34,3V0H0V27.35A600.21,600.21,0,0,0,321.39,56.44Z"
              className="fill-white"
            ></path>
          </svg>
        </div>
      )}
    </div>
  )
}
